const isFunc = func => typeof(func) === 'function'
const isObject = object => typeof(object) === 'object'
const S4 = _ => (((1+Math.random())*0x10000)|0).toString(16).substring(1)
const uuid8 = _ => S4() + S4()
const uuid16 = _ => uuid8() + uuid8()
const uuid32 = _ => uuid16() + uuid16()
const UUID = {uuid8, uuid16 ,uuid32}
const app_request_key = 'zskk-app-request-key-44fc592e3d130402'
const app_response_key = 'zskk-app-response-key-44fc592e3d130402'

const crypto = require('crypto');
const generateSignature = (data, timestamp, random, token = null) => {
    const params = isObject(data) ? JSON.stringify(data) : data
    let md5 = crypto.createHash('md5').update(`${params}:${app_request_key}`).digest('hex')
    md5 = crypto.createHash('md5').update(`${timestamp}:${app_request_key}:${md5}`).digest('hex')
    md5 = crypto.createHash('md5').update(`${random}:${app_request_key}:${md5}`).digest('hex')
    return token ? crypto.createHash('md5').update(`${token}:${app_request_key}:${md5}`).digest('hex') : md5
}

const isErrorNetStatus = status => [200, 201, 202, 203, 204, 205, 301, 302, 304].indexOf(status) == -1
const checkResponse = data => {
    return true
}
const getBrowserEnv = () =>  {
  const ua = navigator.userAgent.toLowerCase();
  if (/micromessenger/.test(ua)) {
    return true;
  }
}
const commonFun = {isFunc, isObject, UUID, generateSignature, isErrorNetStatus, checkResponse, getBrowserEnv}
export default commonFun